import { FC } from "react";
import LinkButton from "../buttons/LinkButton";

interface IEditActions {
  path: string;
  icon?: string;
  name?: string;
}

const EditActions: FC<IEditActions> = (props) => {
  return (
    <>
      <LinkButton
        id="listActionButton"
        name={props.name}
        icon={props.icon}
        path={`/${props.path}`}
      />
    </>
  );
};
export default EditActions;
